module.exports = __webpack_public_path__ + "img/gd.1bfc2836.svg";